

export default {
  name: 'BlogFilterTags',
  props: {
    data: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      activeItems: [],
      filtersTagCodes: [],
    }
  },
  created() {
    this.handleTagFromQueryString();
    // this.handlePreSelectedTags();
  },
  computed: {
    tagCodes () {
      return this.$store.getters['blog/filtersTagCodes']
    },
    isAllTagCodesActive () {
      return this.tagCodes?.length === this.data?.length
    },
    // isTopPicks() {
    //   return this.data?.filter(item => item.IsDefault === true)
    // },
    tagList() {
      return this.data?.filter(item => item.IsDefault !== true)
    },
    topPicksList() {
      return this.data?.filter(item => item.IsDefault === true)
    }
  },
  watch: {
    topPicksList: {
      handler: function (value) {
        this.handlePreSelectedTags();
      },
      deep: true
    }
  },
  methods: {
    saveToStore(value) {
      this.$store.commit('blog/setTagCodes', value)
      console.debug('saveToStore()', this.tagCodes)
    },
    saveAllToStore() {
      this.$store.commit('blog/setAllTagCodes', this.data.map((item, index) => item.DisplayName ))
      console.debug('saveAllToStore()', this.tagCodes)
    },
    handleAllClicked() {
      if (this.isBlogSinglePage()) {
        this.goToBlogListPage()
      }
      if (this.isBlogCategoryPage()) {
        this.goToBlogListPage();
      }
      this.saveAllToStore()

    },
    handleTagClicked(value) {
      if (this.isBlogCategoryPage()) {
        this.goToBlogListPage(value)
        return
      }

      if (this.isBlogSinglePage()) {
        this.goToBlogListPage(value)
        return
      }

      if (this.isAuthorPage()) {
        this.goToBlogListPage(value)
        return
      }

      if (this.isAllTagCodesActive) {
        this.$store.commit('blog/clearTagCodes')
        this.saveToStore(value)
        console.debug('handleTagClicked()', value)
      } else {
        this.saveToStore(value)
      }
    },
    handleTagFromQueryString() {
      const self = this
      const qs = this.$route?.query?.blog_category_filter
      const categories = qs?.split(',')
      if (qs) {
        this.$store.commit('blog/clearTagCodes')
        categories?.forEach(function (el) {
          self.saveToStore(el)
        });
      }
    },
    isAuthorPage() {
      if(this.$route?.name?.includes("blog-author-slug")) {
        return true
      }
      return false
    },
    isBlogSinglePage() {
      if(this.$route?.name?.includes("blog-slug")) {
        return true
      }
      return false
    },
    isBlogCategoryPage() {
      if(this.$route?.name?.includes("blog-category-slug")) {
        return true
      }
      return false
    },
    goToBlogListPage(value) {
      if(value) {
        this.saveToStore(value)
      }
      this.$router.push({
          path: `/${this.$i18n.locale}/blog`,
      })
    },
    handlePreSelectedTags() {
      // pre-select top-picks tag
      if (this.topPicksList.length > 0) {
        this.topPicksList.filter(item => {
          if ( !this.tagCodes.includes(item.DisplayName) ) {
            this.$store.commit('blog/setTagCodes', item.DisplayName)
          }
        })
      }
    }
  },
}
